export const fatchcompletionTypeFind = (completionTypeData, ltsProperties) => {
    return ltsProperties.map((unit) => {
        const matchedUnit = completionTypeData.find((area) => area.type === unit?.completionType);
        return {
            ...unit,
            completionName: matchedUnit ? matchedUnit.name : null,
        };
    });
};
export const objectcompletionType = (completionTypeData, name, key,data) => {
    const matchedUnit = completionTypeData.find((area) => area.type === name);
    return {
        ...data,
        [key]: matchedUnit ? matchedUnit.name : null,
    };
};
export const objectPSSalesType = (pssData,  key,data) => {
     return data.map((unit) => {
        const matchedUnit = pssData.find((item) => item.type === unit?.purposeSalesType);
        return {
            ...unit,
            [key]: matchedUnit ? matchedUnit.name : null,
        };
    });
};
